export default {
    large: 40,
    medium: 17,
    small: 8
};